import { Pagination } from "antd";
import { inject, observer } from "mobx-react";
import React, { Component } from "react";
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "../../constants/tables";
import { ContentDefinitionListUrlParams } from "../../stores/contentDefinitionListStore/contentDefinitionListStoreModel";
import styles from "./ContentDefinitionsFooter.module.scss";
import { ContentDefinitionsFooterProps, InjectedProps } from "./ContentDefinitionsFooterModel";

@inject("contentDefinitionListStore")
@observer
class ContentDefinitionsFooter extends Component<ContentDefinitionsFooterProps> {
  get injected() {
    return this.props as InjectedProps;
  }

  onChangePage = (pageNumber: number) => {
    if (pageNumber !== DEFAULT_PAGE) {
      this.injected.contentDefinitionListStore.searchParams.setUrlParam(
        ContentDefinitionListUrlParams.byPage,
        pageNumber.toString(),
      );
    } else {
      this.injected.contentDefinitionListStore.searchParams.deleteUrlParam(ContentDefinitionListUrlParams.byPage);
    }
  };

  onPaginationChangeSize = (current: number, pageSize: number) => {
    if (pageSize !== DEFAULT_PAGE_SIZE) {
      this.injected.contentDefinitionListStore.searchParams.setUrlParam(
        ContentDefinitionListUrlParams.bySize,
        pageSize.toString(),
      );
    } else {
      this.injected.contentDefinitionListStore.searchParams.setUrlParam(
        ContentDefinitionListUrlParams.bySize,
        pageSize.toString(),
      );
    }
  };

  render() {
    const { currentPage, currentSize } = this.props;
    const { total: totalCount } = this.injected.contentDefinitionListStore.contentDefinitionListData;
    return (
      <Pagination
        className={styles.ContentDefinitionsFooterPagination}
        showSizeChanger={true}
        pageSize={currentSize}
        total={totalCount}
        current={currentPage}
        onChange={this.onChangePage}
        onShowSizeChange={this.onPaginationChangeSize}
      />
    );
  }
}

export default ContentDefinitionsFooter;
